import React, { useState, useRef, useEffect } from 'react';
import './index.css'
import { Icon } from '@ohif/ui';
import { convertKBtoGB } from '@custom/Utils/utils';

const ExtraStoragePlanDetailPopup = ({ isOpen, onClose, data }) => {
  const modalRef = useRef(null);
  const [plan,setPlan] = useState(null);

  const closeHandler = () => {
    onClose();
  };

  const TransformedList = (storageData) => {
  const transformed = storageData.map((item, index) => {
    const [key, value] = Object.entries(item)[0];
    return {
      storage: convertKBtoGB(parseInt(key),5),
      // @ts-ignore
      expiryDate: new Date(value).toLocaleString(), // Optional formatting
      id: index
    };
  })
  return transformed || []
}

  // Handle outside click
  useEffect(() => {
    if(data?.subscriptionDetail?.extraStoragePlan) {
      setPlan(data?.subscriptionDetail?.extraStoragePlan);
    }
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeHandler();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }}
    >
      <div
        ref={modalRef}
        className="bg-white w-full max-w-lg rounded-2xl shadow-xl p-6 relative"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-5">
          <div className="flex items-center">
            <Icon
             className="h-[40px] w-[40px] mr-2"
             name={'extraStorageIcon'}
             />
            <h2 className="text-2xl text-center font-bold text-gray-900">
              Plan Details
            </h2>
          </div>
          <button
            onClick={closeHandler}
            className="text-gray-600 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>

        <hr className="border-gray-300 pb-2"/>

        {/* content */}
        <div style={{ maxHeight: '50vh' }} className="teal-scrollbar overflow-y-scroll pr-2 flex flex-col gap-2">
          <div className="flex justify-between py-2">
            <span className="font-semibold text-gray-900">Plan Name :</span>
            <span>{plan?.planName || 'Plan name'}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="font-semibold text-gray-900">Plan Purchased at :</span>
            <span> {plan?.lastPaymentAt ? new Date(plan.lastPaymentAt).toLocaleDateString() : 'N/A'}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="font-semibold text-gray-900">Plan Lifecycle :</span>
            <span >{plan?.frequency || 'N/A'} months</span>
          </div>
          { plan?.extraStorageExpiryDate?.length > 0 && <div className="flex justify-between flex-col gap-6 py-2">
            {
              plan?.extraStorageExpiryDate?.length > 0 && TransformedList(plan?.extraStorageExpiryDate).map((x:any,index) => {
                return <div className='flex justify-between' key={index}>
                 <span className="font-semibold text-gray-900">Storage Expiry Date ({x.storage} GB) :</span>
                 <span >{x?.expiryDate ? new Date(x?.expiryDate).toLocaleDateString()  : 'N/A'}</span>
                </div>
              })
            }
            </div>}
          <div className="flex justify-between py-2">
            <span className="font-semibold text-gray-900">Credits / GB :</span>
            <span >{plan?.creditsPerGB || 'N/A'}</span>
          </div>
         <div className="flex justify-between py-2">
          <span className="font-semibold text-gray-900">Extra Storage Purchased (GB) :</span>
          <span>
            {data?.subscriptionDetail?.extraStoragePurchasedInKB != null
              ? convertKBtoGB(data.subscriptionDetail.extraStoragePurchasedInKB, 4)
              : 'N/A'}
          </span>
        </div>
        <div className="flex justify-between py-2">
          <span className="font-semibold text-gray-900">Remaining Extra Storage (GB) :</span>
          <span>
            {data?.subscriptionDetail?.remaingingExtraStorageInKB != null
              ? convertKBtoGB(data.subscriptionDetail.remaingingExtraStorageInKB, 5)
              : 'N/A'}
          </span>
        </div>
        <div className="flex justify-between py-2">
          <span className="font-semibold text-gray-900">Main Storage Allocated (GB) :</span>
          <span>
            {data?.subscriptionDetail?.storageAllocatedinKB != null
              ? convertKBtoGB(data.subscriptionDetail.storageAllocatedinKB, 4)
              : 'N/A'}
          </span>
        </div>
        <div className="flex justify-between py-2">
          <span className="font-semibold text-gray-900">Remaining Main Storage (GB) :</span>
          <span>
            {data?.subscriptionDetail?.remainingStorageinKB != null
              ? convertKBtoGB(data.subscriptionDetail.remainingStorageinKB, 5)
              : 'N/A'}
          </span>
        </div>

        </div>
      </div>
    </div>
  );
};

export default ExtraStoragePlanDetailPopup;
